import { Component, Input } from '@angular/core'
import { EditorBanner } from 'src/app/domain/editor'

/** Lock banner (Submitted, Approved, Do Not Resubmit), the rejection reason, or the copied-from note above an editor body. */
@Component({
  selector: 'rt-status-banner',
  template: `
    <ng-container *ngIf="banner as b" [ngSwitch]="b.kind">
      <div *ngSwitchCase="'lock'" class="rt-banner rt-banner--lock rt-tone-{{ $any(b).tone }}" role="status">
        <p class="rt-banner__text">{{ $any(b).text }}</p>
        <p *ngIf="$any(b).reason" class="rt-banner__reason">{{ $any(b).reason }}</p>
      </div>
      <div *ngSwitchCase="'fix'" class="rt-banner rt-banner--fix rt-tone-rejected" role="status">
        <p class="rt-banner__title">Rejected</p>
        <p class="rt-banner__reason">{{ $any(b).reason }}</p>
      </div>
      <div *ngSwitchCase="'note'" class="rt-banner rt-banner--note rt-tone-amber" role="status">
        <p class="rt-banner__text">{{ $any(b).text }}</p>
      </div>
    </ng-container>`,
})
export class RtStatusBannerComponent {
  @Input() banner: EditorBanner = null
}
